export default [
    //common
    {
        path: '/common/mine/serve',
        name: '/common/mine/serve',
        component: () =>
            import ('../views/common/mine/serve'),
            meta:{
                hideShare: true,
            }
    },
    {
        path: '/common/mine/cooperation',
        name: '/common/mine/cooperation',
        component: () =>
            import ('../views/common/mine/cooperation'),
    },
    {
        path: '/common/mine/question/question',
        name: '/common/mine/question/question',
        component: () =>
            import ('../views/common/mine/question/question'),
        meta: {
            name: 'question'
        }
    },
    {
        path: '/common/mine/question/questionDetail',
        name: '/common/mine/question/questionDetail',
        component: () =>
            import ('../views/common/mine/question/questionDetail'),
    },
    {
        path: '/common/protocol/service1',
        name: '/common/protocol/service1',
        component: () =>
            import ('../views//common/protocol/service1.vue'),
            meta:{
                hideShare: true,
            }
    },
    {
        path: '/common/protocol/service',
        name: '/common/protocol/service',
        component: () =>
            import ('../views//common/protocol/service.vue'),
            meta:{
                hideShare: true,
            }
    },
    {
        path: '/common/protocol/children',
        name: '/common/protocol/children',
        component: () =>
            import ('../views//common/protocol/children.vue'),
            meta:{
                hideShare: true,
            }
    },
    {
        path: '/common/protocol/businessLicense',
        name: '/common/protocol/businessLicense',
        component: () =>
            import ('../views//common/protocol/businessLicense.vue'),
            meta:{
                hideShare: true,
            }
    },
    {
        path: '/common/protocol/privacy',
        name: '/common/protocol/privacy',
        component: () =>
            import ('../views/common/protocol/privacy.vue'),
            meta:{
                hideShare: true,
            }
    },
    {
        path: '/common/protocol/vip',
        name: '/common/protocol/vip',
        component: () =>
            import ('../views/common/protocol/vip.vue'),
            meta:{
                hideShare: true,
            }
    },
    {
        path: '/common/protocol/vip1',
        name: '/common/protocol/vip1',
        component: () =>
            import ('../views/common/protocol/vip1.vue'),
            meta:{
                hideShare: true,
            }
    },
    {
        path: '/common/protocol/buy',
        name: '/common/protocol/buy',
        component: () =>
            import ('../views/common/protocol/buy.vue'),
            meta:{
                hideShare: true,
            }
    },
    {
        path: '/common/protocol/sdk',
        name: '/common/protocol/sdk',
        component: () =>
            import ('../views/common/protocol/sdk.vue'),
            meta:{
                hideShare: true,
            }
    },
    {
        path: '/common/protocol/android_sdk',
        name: '/common/protocol/android_sdk',
        component: () =>
            import ('../views/common/protocol/android_sdk.vue'),
            meta:{
                hideShare: true,
            }
    },
    {
        path: '/common/protocol/community',
        name: '/common/protocol/community',
        component: () =>
            import ('../views/common/protocol/community.vue'),
            meta:{
                hideShare: true,
            }
    },
    {
        path: '/common/mine/about',
        name: '/common/mine/about',
        component: () =>
            import ('../views/common/mine/about.vue')
    },
    {
        path: '/common/mine/tel',
        name: '/common/mine/tel',
        component: () =>
            import ('../views/common/mine/tel.vue')
    },
    {
        path: '/404',
        name: '/404',
        component: () =>
            import ('../views/common/404.vue')
    },
    //营销活动  
    {
         path: '/common/marketing/active/index',
         name: '/common/marketing/active/index',
         component: () =>
             import ('../views/common/marketing/active/index.vue')
     },
     {
        path: '/marketing/study/index',
        name: '/marketing/study/index',
        component: () =>
            import ('../views/common/marketing/active/index.vue')
    },
     {
        path: '/common/marketing/active/goods',
        name: '/common/marketing/active/goods',
        component: () =>
            import ('../views/common/marketing/active/goods.vue')
    },
    {
        path: '/common/marketing/active/rule',
        name: '/common/marketing/active/rule',
        component: () =>
            import ('../views/common/marketing/active/rule.vue')
    },
    {
        path: '/common/marketing/active/vip',
        name: '/common/marketing/active/vip',
        component: () =>
            import ('../views/common/marketing/active/vip.vue')
    },
    {
        path: '/common/marketing/active/courseList',
        name: '/common/marketing/active/courseList',
        component: () =>
            import ('../views/common/marketing/active/courseList.vue')
    },

    //双十一
    {
        path: '/common/marketing/novemberActive/index',
        name: '/common/marketing/novemberActive/index',
        component: () =>
            import ('../views/common/marketing/novemberActive/index.vue')
    },
    {
        path: '/common/marketing/novemberActive/wechat',
        name: '/common/marketing/novemberActive/wechat',
        component: () =>
            import ('../views/common/marketing/novemberActive/wechat.vue')
    },
    {
        path: '/common/marketing/novemberActive/vip',
        name: '/common/marketing/novemberActive/vip',
        component: () =>
            import ('../views/common/marketing/novemberActive/vip.vue')
    },
    {
        path: '/common/marketing/novemberActive/courseList',
        name: '/common/marketing/novemberActive/courseList',
        component: () =>
            import ('../views/common/marketing/novemberActive/courseList.vue')
    },
    {         
        path: '/common/marketing/summer/index',
        name: '/common/marketing/summer/index',
        component: () =>
            import ('../views/common/marketing/summer/index.vue')
    },
    {
        path: '/common/marketing/summer/wechat',
        name: '/common/marketing/summer/wechat',
        component: () =>
            import ('../views/common/marketing/summer/wechat.vue')
    },
    {
        path: '/common/marketing/summer/vip',
        name: '/common/marketing/summer/vip',
        component: () =>
            import ('../views/common/marketing/summer/vip.vue')
    },
    {
        path: '/common/marketing/summer/courseList',
        name: '/common/marketing/summer/courseList',
        component: () =>
            import ('../views/common/marketing/summer/courseList.vue')
    },

      //爱艺术+权益课程
      {
        path: '/common/marketing/rightsCourse',
        name: '/common/marketing/rightsCourse',
        component: () =>
            import ('../views/common/marketing/rightsCourse'),
    },
    //  {
    //      path: '/common/marketing/active/group',
    //      name: '/common/marketing/active/group',
    //      component: () =>
    //          import ('../views/common/marketing/active/group.vue')
    //  },
    //  {
    //      path: '/common/marketing/active/branchVenue',
    //      name: '/common/marketing/active/branchVenue',
    //      component: () =>
    //          import ('../views/common/marketing/active/branchVenue.vue')
    //  },
    //  {
    //      path: '/common/marketing/active/invite',
    //      name: '/common/marketing/active/invite',
    //      component: () =>
    //          import ('../views/common/marketing/active/invite.vue')
    //  },
    //  {
    //      path: '/common/marketing/juneActive/index',
    //      name: '/common/marketing/juneActive/index',
    //      component: () =>
    //          import ('../views/common/marketing/juneActive/index.vue')
    //  }, 
]